import React from "react";
import { View, StyleSheet } from "react-native";

import { isSameDay, isTimeGreaterThan } from "libs/utils/dateUtils";
import Text from "./text";
import Button from "./button";
import { ImageMapper } from "src/common/assets/images";
import { SCREEN_WIDTH, TABLET_PC } from "libs/utils/constants";
import variables from "src/common/assets/variables";
import { Image } from "src/common/components/image";
import moment from "moment";
import { getButtonModalWidth } from "../libs/utils/dimensions";

const TIME_IN_ROW = 3;
const WIDTH = TABLET_PC ? getButtonModalWidth() : SCREEN_WIDTH;

const TimePickerInDate = ({
  selectedDate,
  serverTime,
  timeSlots,
  selectedTime,
  selectTime,
  steOpenTime,
}) => {

  const isToday = isSameDay(selectedDate, moment(serverTime).local());

  const Back = ({ text }) => {
    return (
      <Button
        style={styles.buttonLogin}
        solid={false}
        onPress={() => {
          steOpenTime(false);
        }}
      >
        <Image source={ImageMapper.Back} style={styles.backIcon} />
        <Text style={styles.back}>{text}</Text>
      </Button>
    );
  };

  return (
    <View style={styles.timeRoot}>
      {timeSlots.map((it) => {
        if (it.id === -1) {
          return <Back text={it.name} key={it.id.toString()} />;
        }
        const isDisabled = isToday && !isTimeGreaterThan(serverTime, it.name);
        return (
          <Button
            key={it.id}
            style={[
              styles.timeItem,
              selectedTime === it.id && !isDisabled && styles.selectedTimeStyle,
              isDisabled && styles.disabledButton,
            ]}
            solid={false}
            onPress={() => selectTime(it.id)}
            disabled={isDisabled}
            disabledStyle={styles.disabledStyle}
          >
            <Text
              style={[
                styles.name,
                selectedTime === it.id &&
                  !isDisabled &&
                  styles.selectedTimeTextStyle,
              ]}
            >
              {it.name}
            </Text>
          </Button>
        );
      })}
    </View>
  );
};

const styles = StyleSheet.create({
  disabledStyle: {
    backgroundColor: variables.$disabledText,
  },
  disabledButton: {
    borderWidth: 0,
    backgroundColor: variables.$disabledText,
  },
  timeRoot: {
    backgroundColor: "#fff",
    flexDirection: "row",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    paddingLeft: 16,
    paddingTop: 32,
  },
  timeItem: {
    height: 55,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
    width: (WIDTH - (32 + 16 * (TIME_IN_ROW - 1))) / TIME_IN_ROW,
    marginBottom: 32,
    borderColor: "#636E72",
    borderWidth: 1,
    borderRadius: 7,
  },
  name: {
    color: "#636E72",
    fontSize: 14,
    fontFamily: "MontserratBold",
  },
  selectedTimeStyle: {
    backgroundColor: variables.$brandColor,
    borderWidth: 1,
    borderColor: variables.$brandColor,
  },
  selectedTimeTextStyle: {
    color: "#fff",
  },
  buttonLogin: {
    height: 55,
    alignItems: "center",
    justifyContent: "center",
    marginRight: 16,
    width: (WIDTH - 64) / TIME_IN_ROW,
    marginBottom: 32,
    borderRadius: 7,
    flexDirection: "row",
  },
  back: {
    color: "black",
    fontWeight: "400",
    fontSize: 12,
  },
  backIcon: {},
});

export default TimePickerInDate;
